export default {
    IconCopy: () => import('@/Components/Icons/IconCopy.vue'),
    IconClose: () => import('@/Components/Icons/IconClose.vue'),
    IconInformation: () => import('@/Components/Icons/IconInformation.vue'),
    IconPencil: () => import('@/Components/Icons/IconPencil.vue'),
}
